import { createFileRoute } from '@tanstack/react-router'
import { AccountPage } from 'pages/app/account/AccountPage'

export const Route = createFileRoute('/_authenticated/app/konto')({
  component: AccountPage,
})
